import { render } from "./MainUsers.vue?vue&type=template&id=3b5e2e38"
import script from "./MainUsers.vue?vue&type=script&lang=js"
export * from "./MainUsers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__